import {
    GenericSuspense,
    IconButton,
    RightSidebar,
    useBreakpoints,
    useUrlParamsValue
} from "@bsm/component";
import { calendarOpenState } from "components/layout/AdminNavBar";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import BarLoader from 'react-spinners/BarLoader';
import { useRecoilState } from "recoil";
import { AdminLeftSideBar } from "./AdminLeftSideBar";
import { AdminNavBar as NavBar } from "./AdminNavBar";
import { NotificationDialog } from "@bsm/notification";
import { ChevronsLeft, ChevronsRight } from 'lucide-react';

const AdminLayout = () => {
    const { sm } = useBreakpoints()
    const [openSidebar, setOpenSidebar] = useState(!sm);

    const toogleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    return (
        <>
            <div className="admin-layout flex w-full relative">
                <AdminLeftSideBar open={openSidebar} />

                <main className="w-[calc(100%-296px)] transition-all duration-1000 ease-in-out flex-1 flex flex-col !bg-body-background">
                    <NavBar onToggleSidebar={() => toogleSidebar()} openedToggleSidebar={openSidebar}/>
                    <GenericSuspense
                        fallback={
                            <BarLoader className='main-spinner-bar-loader shadow-sm' width="100%" />
                        }
                    >
                        <div className="flex items-start justify-center w-full p-0 parent-layout">
                            <Outlet />
                        </div>
                    </GenericSuspense>
                </main>
            </div>

            <NotificationDialog />
        </>
    );
};

export default AdminLayout;
